import styled from 'styled-components';

export const Container = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  width: 420px;
  border-radius: 8px;
  background-color: #fff;
`;

export const Header = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 10px 0;
`;

export const Body = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: max-content;
  padding: 0px 40px 36px 40px;
`;
